import React from "react";
import PropTypes from "prop-types";
import { FaTwitter } from "react-icons/fa/";

import config from "../../../content/meta/config";
import avatar from "../../images/jpg/avatar-big.jpg";

const Author = props => {
  const { note, theme } = props;

  return (
    <React.Fragment>
      <div className="author">
        <img src={avatar} alt={config.siteTitle} className="avatar" />

        <h3>About Nicolas Cognaux</h3>

        <div className="note" dangerouslySetInnerHTML={{ __html: note }} />
        <a
          href="https://twitter.com/Gp2mv3"
          target="_blank"
          rel="noopener noreferrer"
          className="twitter-follow"
        >
          <FaTwitter /> Follow : @Gp2mv3
        </a>
      </div>

      {/* --- STYLES --- */}
      <style jsx>{`
        .author {
          margin: 0;
          padding: ${theme.space.l} 0 0 0;

          h3 {
            text-align: center;
            margin-bottom: 10px;
          }

          .avatar {
            display: block;
            width: 70%;
            margin: auto;
            margin-bottom: 30px;
          }

          .note {
            font-size: 0.9em;
            line-height: 1.6;
          }

          .twitter-follow {
            border: 1px solid transparent;
            padding: 15px;
            color: rgb(29, 161, 242);
            font-weight: bold;
            border-radius: 8px;
            text-align: center;
            display: block;
            margin: 0px;
            margin-top: 10px;
            margin-bottom: 15px;

            transition: all 0.3s linear;

            :hover {
              border: 1px solid rgba(29, 161, 242, 0.7);
            }
          }
        }

        @from-width tablet {
          .avatar {
            flex: 0 0 auto;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Author.propTypes = {
  note: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired
};

export default Author;
